import React from 'react'

interface LoadingSpinnerProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
  color?: string
  progress?: number // Novo: progresso de 0 a 100
}

export function LoadingSpinner({ 
  message = 'Carregando...', 
  size = 'medium',
  color = '#0072BB',
  progress
}: LoadingSpinnerProps) {
  const sizeMap = {
    small: '20px',
    medium: '40px',
    large: '60px'
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#EFF4F6',
      color: '#333',
      fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      {/* Spinner */}
      <div style={{
        width: sizeMap[size],
        height: sizeMap[size],
        border: `3px solid #f3f3f3`,
        borderTop: `3px solid ${color}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '1rem'
      }} />
      
      {/* Mensagem */}
      <div style={{
        fontSize: size === 'small' ? '14px' : size === 'medium' ? '16px' : '18px',
        fontWeight: 500,
        color: '#666',
        marginBottom: progress !== undefined ? '1rem' : '0'
      }}>
        {message}
      </div>

      {/* Barra de progresso (opcional) */}
      {progress !== undefined && (
        <div style={{
          width: '200px',
          height: '4px',
          background: '#f3f3f3',
          borderRadius: '2px',
          overflow: 'hidden',
          marginTop: '0.5rem'
        }}>
          <div style={{
            width: `${progress}%`,
            height: '100%',
            background: color,
            borderRadius: '2px',
            transition: 'width 0.3s ease'
          }} />
        </div>
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
} 